import { gettext } from '@eventbrite/i18n';
import ELLA_KAHAN from '../static/images/ella-kahan.webp';
import ERIC_GOLDIE from '../static/images/eric-goldie.webp';
import INSTAGRAM_ICON from '../static/images/icon-instagram.svg';
import TIKTOK_ICON from '../static/images/icon-tiktok.svg';
import JUSTIN_MATIAS from '../static/images/justin-matias.webp';
import MICHELLE_JAVIER from '../static/images/michelle-javier.webp';
import REBEKA_GETTY from '../static/images/rebeka-getty.webp';

export const TITLE = gettext('Insider guides to New York City');
export const SUBTITLE = gettext(
    'Explore the best things to do in the city, curated by local experts',
);

export const INFLUENCER_CURATION_PLACE_ID: { [key: string]: string } = {
    NEW_YORK: '85977539',
};

export const INFLUENCER_CURATION_PLACES = [
    INFLUENCER_CURATION_PLACE_ID.NEW_YORK,
];

export const SOCIAL_PLATFORMS = {
    INSTAGRAM: 'instagram',
    TIKTOK: 'tiktok',
};

export const SOCIAL_PLATFORM_DETAILS = {
    [SOCIAL_PLATFORMS.INSTAGRAM]: {
        icon: INSTAGRAM_ICON,
        link: 'https://www.instagram.com/',
    },
    [SOCIAL_PLATFORMS.TIKTOK]: {
        icon: TIKTOK_ICON,
        link: 'https://www.tiktok.com/@',
    },
};

export const ALLINFLUENCERSDETAILS = [
    {
        title: 'NYC eats & drinks by',
        name: 'Ella Kahan',
        social: [
            {
                handle: 'chewyorkcity',
                platform: SOCIAL_PLATFORMS.INSTAGRAM,
            },
            {
                handle: 'chewyorkcity',
                platform: SOCIAL_PLATFORMS.TIKTOK,
            },
        ],
        interests: 'Food/bev',
        image: ELLA_KAHAN,
        collection_id: 'ccmxcyyq',
    },
    {
        title: 'Spring events in NYC by',
        name: 'Eric Goldie',
        social: [
            {
                handle: 'ericgoldie',
                platform: SOCIAL_PLATFORMS.INSTAGRAM,
            },
            {
                handle: 'ericgoldie',
                platform: SOCIAL_PLATFORMS.TIKTOK,
            },
        ],
        interests: 'Things to do',
        image: ERIC_GOLDIE,
        collection_id: 'ccmxcyxh',
    },
    {
        title: 'Free events in NYC by',
        name: 'Rebeka Getty',
        social: [
            {
                handle: 'nycforfree',
                platform: SOCIAL_PLATFORMS.INSTAGRAM,
            },
            {
                handle: 'nycforfree',
                platform: SOCIAL_PLATFORMS.TIKTOK,
            },
        ],
        interests: 'Free events',
        image: REBEKA_GETTY,
        collection_id: 'ccmxcyxz',
    },
    {
        title: 'Only in NYC by',
        name: 'Justin Matias',
        social: [
            {
                handle: 'ferriswheeljay',
                platform: SOCIAL_PLATFORMS.INSTAGRAM,
            },
            {
                handle: 'ferriswheeljay',
                platform: SOCIAL_PLATFORMS.TIKTOK,
            },
        ],
        interests: 'Things to do',
        image: JUSTIN_MATIAS,
        collection_id: 'ccmxcywt',
    },
    {
        title: 'Explore NYC my way by',
        name: 'Michelle Javier',
        social: [
            {
                handle: 'michellemariejavier',
                platform: SOCIAL_PLATFORMS.INSTAGRAM,
            },
            {
                handle: 'michellemariejavier',
                platform: SOCIAL_PLATFORMS.TIKTOK,
            },
        ],
        interests: 'Things to do',
        image: MICHELLE_JAVIER,
        collection_id: 'ccmxcywc',
    },
];
